<script setup lang="ts">
withDefaults(
  defineProps<{
    fill?: string
  }>(),
  {
    fill: '#006BAE',
  }
)
</script>

<template>
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M22.5918 12.2051L24.3595 10.4373C25.3359 9.461 26.9188 9.461 27.8951 10.4373L38.4229 20.9652L38.4251 20.963L40.5464 23.0843C41.3275 23.8654 41.3275 25.1317 40.5464 25.9127L40.2743 26.1849C40.2479 26.2139 40.2207 26.2424 40.1926 26.2704L38.4249 28.0382L38.4229 28.0362L27.8953 38.5639C26.919 39.5402 25.3361 39.5402 24.3598 38.5639L22.592 36.7961L32.3876 27.0005H8.5C7.11929 27.0005 6 25.8812 6 24.5005V22.0005H32.3872L22.5918 12.2051Z"
      :fill="fill"
    />
  </svg>
</template>
